import { GetMeCoachResult } from '@airreading/common/data';
import { Alert, AlertTitle } from '@/components/ui/alert.js';
import { Lightbulb } from 'lucide-react';
import { formatPlainDate, FrequentTimeZones } from '@airreading/common';
import { Temporal } from 'temporal-polyfill';

export const PaymentAlert = (props: GetMeCoachResult) => {
  const {
    paymentAccountConnectedAtInstant,
    paymentAccountUpdatedAtInstant,
    paymentAccountErrorAtInstant,
    paymentAccountErrorMessage,
    timeZone,
  } = props;

  const shouldShowAlert = (instant: Temporal.Instant) =>
    Temporal.Instant.compare(instant.add({ hours: 24 }), Temporal.Now.instant()) > 0;

  if (paymentAccountErrorAtInstant && shouldShowAlert(paymentAccountErrorAtInstant)) {
    return (
      <Alert
        className="p-3 flex items-center [&>svg]:top-3 [&>svg]:left-3 bg-[#FFEBEB] text-[#eb404a] border-[#eb404a]"
        variant="destructive"
      >
        <Lightbulb className="w-4 h-4 font-semibold" />
        <AlertTitle className="flex items-center m-0 px-1 font-semibold">{`Unable to ${paymentAccountConnectedAtInstant ? 'update' : 'add'} the Direct Deposit info. Bank Error: ${paymentAccountErrorMessage} Please check your info and try again, or contact the Air Reading support. Thank you.`}</AlertTitle>
      </Alert>
    );
  }

  if (paymentAccountUpdatedAtInstant && shouldShowAlert(paymentAccountUpdatedAtInstant)) {
    return (
      <Alert className="p-3 flex items-center [&>svg]:top-3 [&>svg]:left-3" variant="success">
        <Lightbulb className="w-4 h-4 font-semibold" />
        <AlertTitle className="flex items-center m-0 px-1 font-semibold">{`Direct Deposit info updated successfully on ${formatPlainDate(
          Temporal.Instant.from(paymentAccountUpdatedAtInstant)
            .toZonedDateTimeISO(timeZone ?? FrequentTimeZones.UTC)
            .toPlainDate(),
        )}`}</AlertTitle>
      </Alert>
    );
  }

  if (paymentAccountConnectedAtInstant && shouldShowAlert(paymentAccountConnectedAtInstant)) {
    return (
      <Alert className="p-3 flex items-center [&>svg]:top-3 [&>svg]:left-3" variant="success">
        <Lightbulb className="w-4 h-4 font-semibold" />
        <AlertTitle className="flex items-center m-0 px-1 font-semibold">{`Direct Deposit info added successfully on ${formatPlainDate(
          Temporal.Instant.from(paymentAccountConnectedAtInstant)
            .toZonedDateTimeISO(timeZone ?? FrequentTimeZones.UTC)
            .toPlainDate(),
        )}`}</AlertTitle>
      </Alert>
    );
  }

  return null;
};
